import { InjectionToken, Provider } from '@angular/core';
import { PaymentRepository } from '../../domain/payment.repository';
import { PaymentService } from '../payment/payment.service';

export const PAYMENT_REPOSITORY = new InjectionToken<PaymentRepository>('PaymentRepository');

export const PAYMENT_API_PROVIDER: Provider = {
    provide: PaymentRepository,
    useClass: PaymentService,
};
